
// import React, { useState, useEffect } from "react";
// import {
//   PlusCircle,
//   Edit2,
//   Trash2,
//   TrendingUp,
//   Calendar,
//   DollarSign,
//   PieChart,
// } from "lucide-react";
// import Swal from "sweetalert2";

// import { Api } from "../Api/Api";



// const API_URL = Api + "expense/api.php";



// const ExpenseTracker = () => {
//   const [expenses, setExpenses] = useState([]);
//   const [summary, setSummary] = useState({
//     total: 0,
//     count: 0,
//     categories: [],
//   });
//   const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
//   const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
//   const [showForm, setShowForm] = useState(false);
//   const [editingExpense, setEditingExpense] = useState(null);
//   const [formData, setFormData] = useState({
//     title: "",
//     amount: "",
//     category: "",
//     date: new Date().toISOString().split("T")[0],
//     description: "",
//   });

//   const categories = [
//     "Food & Dining",
//     "Transportation",
//     "Shopping",
//     "Entertainment",
//     "Bills & Utilities",
//     "Healthcare",
//     "Education",
//     "Travel",
//     "Other",
//   ];

//   const months = [
//     "January",
//     "February",
//     "March",
//     "April",
//     "May",
//     "June",
//     "July",
//     "August",
//     "September",
//     "October",
//     "November",
//     "December",
//   ];

//   useEffect(() => {
//     fetchExpenses();
//     fetchSummary();
//   }, [selectedMonth, selectedYear]);

//   const fetchExpenses = async () => {
//     try {
//       const response = await fetch(
//         `${API_URL}/expenses?month=${selectedMonth}&year=${selectedYear}`
//       );
//       const data = await response.json();
//       if (data.success) {
//         setExpenses(data.data);
//       }
//     } catch (error) {
//       console.error("Error fetching expenses:", error);
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Failed to fetch expenses. Please try again.",
//         confirmButtonColor: "#4F46E5",
//       });
//     }
//   };

//   const fetchSummary = async () => {
//     try {
//       const response = await fetch(
//         `${API_URL}/summary?month=${selectedMonth}&year=${selectedYear}`
//       );
//       const data = await response.json();
//       if (data.success) {
//         setSummary(data.data);
//       }
//     } catch (error) {
//       console.error("Error fetching summary:", error);
//     }
//   };

//   const handleSubmit = async () => {
//     if (
//       !formData.title ||
//       !formData.amount ||
//       !formData.category ||
//       !formData.date
//     ) {
//       Swal.fire({
//         icon: "warning",
//         title: "Missing Fields",
//         text: "Please fill in all required fields",
//         confirmButtonColor: "#4F46E5",
//       });
//       return;
//     }

//     try {
//       const url = editingExpense
//         ? `${API_URL}/expenses/${editingExpense.id}`
//         : `${API_URL}/expenses`;

//       const method = editingExpense ? "PUT" : "POST";

//       const response = await fetch(url, {
//         method,
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(formData),
//       });

//       const data = await response.json();

//       if (data.success) {
//         await fetchExpenses();
//         await fetchSummary();
//         resetForm();

//         Swal.fire({
//           icon: "success",
//           title: editingExpense ? "Updated!" : "Added!",
//           text: editingExpense
//             ? "Expense updated successfully"
//             : "Expense added successfully",
//           timer: 1500,
//           showConfirmButton: false,
//         });
//       } else {
//         throw new Error(data.message || "Failed to save expense");
//       }
//     } catch (error) {
//       console.error("Error saving expense:", error);
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Failed to save expense. Please try again.",
//         confirmButtonColor: "#4F46E5",
//       });
//     }
//   };

//   const handleDelete = async (id) => {
//     const result = await Swal.fire({
//       title: "Are you sure?",
//       text: "You won't be able to revert this!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#EF4444",
//       cancelButtonColor: "#6B7280",
//       confirmButtonText: "Yes, delete it!",
//       cancelButtonText: "Cancel",
//     });

//     if (!result.isConfirmed) return;

//     try {
//       const response = await fetch(`${API_URL}/expenses/${id}`, {
//         method: "DELETE",
//       });

//       const data = await response.json();

//       if (data.success) {
//         await fetchExpenses();
//         await fetchSummary();

//         Swal.fire({
//           icon: "success",
//           title: "Deleted!",
//           text: "Expense has been deleted successfully",
//           timer: 1500,
//           showConfirmButton: false,
//         });
//       } else {
//         throw new Error(data.message || "Failed to delete expense");
//       }
//     } catch (error) {
//       console.error("Error deleting expense:", error);
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Failed to delete expense. Please try again.",
//         confirmButtonColor: "#4F46E5",
//       });
//     }
//   };

//   const handleEdit = (expense) => {
//     setEditingExpense(expense);
//     setFormData({
//       title: expense.title,
//       amount: expense.amount,
//       category: expense.category,
//       date: expense.date,
//       description: expense.description || "",
//     });
//     setShowForm(true);
//   };

//   const resetForm = () => {
//     setFormData({
//       title: "",
//       amount: "",
//       category: "",
//       date: new Date().toISOString().split("T")[0],
//       description: "",
//     });
//     setEditingExpense(null);
//     setShowForm(false);
//   };

//   const getCategoryColor = (category) => {
//     const colors = {
//       "Food & Dining": "bg-orange-100 text-orange-700",
//       Transportation: "bg-blue-100 text-blue-700",
//       Shopping: "bg-purple-100 text-purple-700",
//       Entertainment: "bg-pink-100 text-pink-700",
//       "Bills & Utilities": "bg-yellow-100 text-yellow-700",
//       Healthcare: "bg-red-100 text-red-700",
//       Education: "bg-green-100 text-green-700",
//       Travel: "bg-indigo-100 text-indigo-700",
//       Other: "bg-gray-100 text-gray-700",
//     };
//     return colors[category] || "bg-gray-100 text-gray-700";
//   };

//   return (
//     <div className="min-h-screen  p-4 md:p-8">
//       <div className="max-w-6xl mx-auto">
//         {/* Header */}
//         <div className="bg-white rounded-2xl shadow-xl p-6 mb-6">
//           <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
//             <div>
//               <h1 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
//                 <DollarSign className="text-indigo-600" />
//                 Expense Tracker
//               </h1>
//               <p className="text-gray-600 mt-1">Manage your monthly expenses</p>
//             </div>

//             <div className="flex gap-3">
//               <select
//                 value={selectedMonth}
//                 onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
//                 className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
//               >
//                 {months.map((month, index) => (
//                   <option key={index} value={index + 1}>
//                     {month}
//                   </option>
//                 ))}
//               </select>

//               <select
//                 value={selectedYear}
//                 onChange={(e) => setSelectedYear(parseInt(e.target.value))}
//                 className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
//               >
//                 {[2024, 2025, 2026].map((year) => (
//                   <option key={year} value={year}>
//                     {year}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>
//         </div>

//         {/* Summary Cards */}
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
//           <div className="bg-white rounded-xl shadow-lg p-6">
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-gray-600 text-sm font-medium">
//                   Total Expenses
//                 </p>
//                 <p className="text-3xl font-bold text-indigo-600 mt-2">
//                   ${parseFloat(summary.total || 0).toFixed(2)}
//                 </p>
//               </div>
//               <div className="bg-indigo-100 p-3 rounded-full">
//                 <TrendingUp className="text-indigo-600" size={24} />
//               </div>
//             </div>
//           </div>

//           <div className="bg-white rounded-xl shadow-lg p-6">
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-gray-600 text-sm font-medium">
//                   Transactions
//                 </p>
//                 <p className="text-3xl font-bold text-green-600 mt-2">
//                   {summary.count || 0}
//                 </p>
//               </div>
//               <div className="bg-green-100 p-3 rounded-full">
//                 <Calendar className="text-green-600" size={24} />
//               </div>
//             </div>
//           </div>

//           <div className="bg-white rounded-xl shadow-lg p-6">
//             <div className="flex items-center justify-between">
//               <div>
//                 <p className="text-gray-600 text-sm font-medium">Categories</p>
//                 <p className="text-3xl font-bold text-purple-600 mt-2">
//                   {summary.categories?.length || 0}
//                 </p>
//               </div>
//               <div className="bg-purple-100 p-3 rounded-full">
//                 <PieChart className="text-purple-600" size={24} />
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Category Breakdown */}
//         {summary.categories && summary.categories.length > 0 && (
//           <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
//             <h2 className="text-xl font-bold text-gray-800 mb-4">
//               Category Breakdown
//             </h2>
//             <div className="space-y-3">
//               {summary.categories.map((cat) => (
//                 <div
//                   key={cat.category}
//                   className="flex items-center justify-between"
//                 >
//                   <div className="flex items-center gap-3 flex-1">
//                     <span
//                       className={`px-3 py-1 rounded-full text-sm font-medium ${getCategoryColor(
//                         cat.category
//                       )}`}
//                     >
//                       {cat.category}
//                     </span>
//                     <div className="flex-1 bg-gray-200 rounded-full h-2">
//                       <div
//                         className="bg-indigo-600 h-2 rounded-full"
//                         style={{
//                           width: `${(cat.total / summary.total) * 100}%`,
//                         }}
//                       />
//                     </div>
//                   </div>
//                   <div className="text-right ml-4">
//                     <p className="font-bold text-gray-800">
//                       ${parseFloat(cat.total).toFixed(2)}
//                     </p>
//                     <p className="text-sm text-gray-600">{cat.count} items</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* Add Expense Button */}
//         <div className="mb-6">
//           <button
//             onClick={() => setShowForm(!showForm)}
//             className="bg-indigo-600 text-white px-6 py-3 rounded-lg font-medium flex items-center gap-2 hover:bg-indigo-700 transition-colors shadow-lg"
//           >
//             <PlusCircle size={20} />
//             Add Expense
//           </button>
//         </div>

//         {/* Expense Form */}
//         {showForm && (
//           <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
//             <h2 className="text-xl font-bold text-gray-800 mb-4">
//               {editingExpense ? "Edit Expense" : "Add New Expense"}
//             </h2>
//             <div className="space-y-4">
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Title
//                   </label>
//                   <input
//                     type="text"
//                     value={formData.title}
//                     onChange={(e) =>
//                       setFormData({ ...formData, title: e.target.value })
//                     }
//                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
//                     placeholder="Grocery shopping"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Amount
//                   </label>
//                   <input
//                     type="number"
//                     step="0.01"
//                     value={formData.amount}
//                     onChange={(e) =>
//                       setFormData({ ...formData, amount: e.target.value })
//                     }
//                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
//                     placeholder="0.00"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Category
//                   </label>
//                   <select
//                     value={formData.category}
//                     onChange={(e) =>
//                       setFormData({ ...formData, category: e.target.value })
//                     }
//                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
//                   >
//                     <option value="">Select category</option>
//                     {categories.map((cat) => (
//                       <option key={cat} value={cat}>
//                         {cat}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Date
//                   </label>
//                   <input
//                     type="date"
//                     value={formData.date}
//                     onChange={(e) =>
//                       setFormData({ ...formData, date: e.target.value })
//                     }
//                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
//                   />
//                 </div>
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   Description (Optional)
//                 </label>
//                 <textarea
//                   value={formData.description}
//                   onChange={(e) =>
//                     setFormData({ ...formData, description: e.target.value })
//                   }
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
//                   rows="3"
//                   placeholder="Additional details..."
//                 />
//               </div>

//               <div className="flex gap-3">
//                 <button
//                   onClick={handleSubmit}
//                   className="bg-indigo-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-indigo-700 transition-colors"
//                 >
//                   {editingExpense ? "Update" : "Add"} Expense
//                 </button>
//                 <button
//                   onClick={resetForm}
//                   className="bg-gray-300 text-gray-700 px-6 py-2 rounded-lg font-medium hover:bg-gray-400 transition-colors"
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Expenses List */}
//         <div className="bg-white rounded-xl shadow-lg p-6">
//           <h2 className="text-xl font-bold text-gray-800 mb-4">
//             Expenses for {months[selectedMonth - 1]} {selectedYear}
//           </h2>

//           {expenses.length === 0 ? (
//             <div className="text-center py-12 text-gray-500">
//               <p className="text-lg">No expenses found for this month</p>
//               <p className="text-sm mt-2">
//                 Start by adding your first expense!
//               </p>
//             </div>
//           ) : (
//             <div className="space-y-3">
//               {expenses.map((expense) => (
//                 <div
//                   key={expense.id}
//                   className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow"
//                 >
//                   <div className="flex flex-col md:flex-row justify-between gap-3">
//                     <div className="flex-1">
//                       <div className="flex items-center gap-3 mb-2">
//                         <h3 className="font-semibold text-gray-800 text-lg">
//                           {expense.title}
//                         </h3>
//                         <span
//                           className={`px-2 py-1 rounded-full text-xs font-medium ${getCategoryColor(
//                             expense.category
//                           )}`}
//                         >
//                           {expense.category}
//                         </span>
//                       </div>
//                       {expense.description && (
//                         <p className="text-gray-600 text-sm mb-2">
//                           {expense.description}
//                         </p>
//                       )}
//                       <p className="text-gray-500 text-sm">
//                         {new Date(expense.date).toLocaleDateString("en-US", {
//                           weekday: "short",
//                           year: "numeric",
//                           month: "short",
//                           day: "numeric",
//                         })}
//                       </p>
//                     </div>

//                     <div className="flex items-center gap-3">
//                       <div className="text-right">
//                         <p className="text-2xl font-bold text-indigo-600">
//                           ${parseFloat(expense.amount).toFixed(2)}
//                         </p>
//                       </div>

//                       <div className="flex gap-2">
//                         <button
//                           onClick={() => handleEdit(expense)}
//                           className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
//                         >
//                           <Edit2 size={18} />
//                         </button>
//                         <button
//                           onClick={() => handleDelete(expense.id)}
//                           className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
//                         >
//                           <Trash2 size={18} />
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ExpenseTracker;


import React, { useState, useEffect } from "react";
import {
  PlusCircle,
  Edit2,
  Trash2,
  TrendingUp,
  Calendar,
  PieChart,
} from "lucide-react";
import Swal from "sweetalert2";
import { Api } from "../Api/Api";

const API_URL = Api + "expense/api.php";

const ExpenseTracker = () => {
  const [expenses, setExpenses] = useState([]);
  const [summary, setSummary] = useState({
    totalIncome: 0,
    totalExpense: 0,
    balance: 0,
  });

  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  const [showForm, setShowForm] = useState(false);
  const [editingExpense, setEditingExpense] = useState(null);

  const [formData, setFormData] = useState({
    title: "",
    amount: "",
    type: "expense",
    date: new Date().toISOString().split("T")[0],
  });

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  useEffect(() => {
    fetchExpenses();
    fetchSummary();
  }, [selectedMonth, selectedYear]);

  const fetchExpenses = async () => {
    const response = await fetch(
      `${API_URL}/expenses?month=${selectedMonth}&year=${selectedYear}`,
    );
    const data = await response.json();
    if (data.success) setExpenses(data.data);
  };

  const fetchSummary = async () => {
    const response = await fetch(
      `${API_URL}/summary?month=${selectedMonth}&year=${selectedYear}`,
    );
    const data = await response.json();
    if (data.success) setSummary(data.data);
  };

  const handleSubmit = async () => {
    if (!formData.title || !formData.amount || !formData.date) {
      Swal.fire("Missing Fields", "Fill all required fields", "warning");
      return;
    }

    const url = editingExpense
      ? `${API_URL}/expenses/${editingExpense.id}`
      : `${API_URL}/expenses`;

    const method = editingExpense ? "PUT" : "POST";

    const response = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    const data = await response.json();

    if (data.success) {
      fetchExpenses();
      fetchSummary();
      resetForm();
      Swal.fire("Success", "Saved successfully", "success");
    }
  };

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Delete?",
      icon: "warning",
      showCancelButton: true,
    });

    if (!confirm.isConfirmed) return;

    await fetch(`${API_URL}/expenses/${id}`, { method: "DELETE" });

    fetchExpenses();
    fetchSummary();
  };

  const handleEdit = (expense) => {
    setEditingExpense(expense);
    setFormData(expense);
    setShowForm(true);
  };

  const resetForm = () => {
    setFormData({
      title: "",
      amount: "",
      type: "expense",
      date: new Date().toISOString().split("T")[0],
    });
    setEditingExpense(null);
    setShowForm(false);
  };

  return (
    <div className="min-h-screen p-6 bg-gray-100">
      <div className="max-w-6xl mx-auto">
        {/* HEADER */}
        <div className="bg-white p-4 sm:p-6 rounded-xl border border-slate-200 shadow-sm mb-6">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
            {/* Title Section */}
            <div>
              <h1 className="text-xl sm:text-2xl font-bold text-slate-800 tracking-tight">
                Income & Expense Tracker
              </h1>
              <p className="text-xs sm:text-sm text-slate-500 font-medium">
                Financial overview for the selected period
              </p>
            </div>

            {/* Controls Section */}
            <div className="flex flex-wrap sm:flex-nowrap items-center gap-2 sm:gap-3">
              <div className="relative flex-1 sm:flex-none">
                <select
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
                  className="w-full appearance-none bg-slate-50 border border-slate-300 text-slate-700 py-2 pl-3 pr-8 rounded-lg text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-all cursor-pointer"
                >
                  {months.map((month, index) => (
                    <option key={index} value={index + 1}>
                      {month}
                    </option>
                  ))}
                </select>
                {/* Custom Arrow for professional look */}
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-slate-500">
                  <svg className="h-4 w-4 fill-current" viewBox="0 0 20 20">
                    <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                  </svg>
                </div>
              </div>

              <div className="relative flex-1 sm:flex-none">
                <select
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                  className="w-full appearance-none bg-slate-50 border border-slate-300 text-slate-700 py-2 pl-3 pr-8 rounded-lg text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-all cursor-pointer"
                >
                  {[2024, 2025, 2026].map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-slate-500">
                  <svg className="h-4 w-4 fill-current" viewBox="0 0 20 20">
                    <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                  </svg>
                </div>
              </div>

              {/* Optional: Add a subtle Refresh or Filter Button for a more pro feel */}
           
            </div>
          </div>
        </div>
        {/* SUMMARY CARDS */}
        <div className="grid md:grid-cols-3 gap-6 mb-6">
          <div className="bg-white p-6 rounded-xl shadow">
            <p className="text-gray-500">Total Income</p>
            <h2 className="text-2xl font-bold text-green-600">
              ₹{parseFloat(summary.totalIncome || 0).toFixed(2)}
            </h2>
          </div>

          <div className="bg-white p-6 rounded-xl shadow">
            <p className="text-gray-500">Total Expense</p>
            <h2 className="text-2xl font-bold text-red-600">
              ₹{parseFloat(summary.totalExpense || 0).toFixed(2)}
            </h2>
          </div>

          <div className="bg-white p-6 rounded-xl shadow">
            <p className="text-gray-500">Balance</p>
            <h2
              className={`text-2xl font-bold ${
                summary.balance >= 0 ? "text-green-600" : "text-red-600"
              }`}
            >
              ₹{parseFloat(summary.balance || 0).toFixed(2)}
            </h2>
          </div>
        </div>

        {/* ADD BUTTON */}
        <button
          onClick={() => setShowForm(!showForm)}
          className="bg-indigo-600 text-white px-4 py-2 rounded mb-6"
        >
          <PlusCircle size={18} className="inline mr-2" />
          Add Income / Expense
        </button>

        {/* FORM */}
        {showForm && (
          <div className="bg-white p-6 rounded-xl shadow mb-6">
            <div className="grid md:grid-cols-2 gap-4">
              <input
                type="text"
                placeholder="Title"
                value={formData.title}
                onChange={(e) =>
                  setFormData({ ...formData, title: e.target.value })
                }
                className="border p-2 rounded"
              />

              <input
                type="number"
                placeholder="Amount"
                value={formData.amount}
                onChange={(e) =>
                  setFormData({ ...formData, amount: e.target.value })
                }
                className="border p-2 rounded"
              />

              <select
                value={formData.type}
                onChange={(e) =>
                  setFormData({ ...formData, type: e.target.value })
                }
                className="border p-2 rounded"
              >
                <option value="expense">Expense</option>
                <option value="income">Income</option>
              </select>

              <input
                type="date"
                value={formData.date}
                onChange={(e) =>
                  setFormData({ ...formData, date: e.target.value })
                }
                className="border p-2 rounded"
              />
            </div>

            <div className="mt-4">
              <button
                onClick={handleSubmit}
                className="bg-green-600 text-white px-4 py-2 rounded mr-2"
              >
                Save
              </button>

              <button
                onClick={resetForm}
                className="bg-gray-400 text-white px-4 py-2 rounded"
              >
                Cancel
              </button>
            </div>
          </div>
        )}

        {/* LIST */}
        <div className="bg-white p-6 rounded-xl shadow">
          <h2 className="font-semibold mb-4">
            {months[selectedMonth - 1]} {selectedYear} Transactions
          </h2>

          {expenses.length === 0 ? (
            <p className="text-gray-500">No transactions for this month.</p>
          ) : (
            expenses.map((expense) => (
              <div
                key={expense.id}
                className="flex justify-between border-b py-3"
              >
                <div>
                  <div className="flex items-center gap-2">
                    <p className="font-semibold">{expense.title}</p>

                    {/* TYPE BADGE */}
                    <span
                      className={`px-2 py-1 text-xs rounded-full font-medium ${
                        expense.type === "income"
                          ? "bg-green-100 text-green-700"
                          : "bg-red-100 text-red-700"
                      }`}
                    >
                      {expense.type === "income" ? "Income" : "Expense"}
                    </span>
                  </div>

                  <p className="text-sm text-gray-500">{expense.date}</p>
                </div>

                <div className="flex items-center gap-3">
                  <p
                    className={`font-bold ${
                      expense.type === "income"
                        ? "text-green-600"
                        : "text-red-600"
                    }`}
                  >
                    ₹{parseFloat(expense.amount).toFixed(2)}
                  </p>

                  <button onClick={() => handleEdit(expense)}>
                    <Edit2 size={18} />
                  </button>

                  <button onClick={() => handleDelete(expense.id)}>
                    <Trash2 size={18} />
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default ExpenseTracker;
